import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { DataSource } from '~/Api/DataSource';
import GroupedDataSource from '~/Api/DataSource/GroupedDataSource';
import { fetchDataSourcesIfNeeded } from '~/ProductSearchableDataSource';
import { ApplicationState, ThunkDispatch } from '~/Store';

import DatasourceSelect from './DatasourceSelect';

function mapStateToProps(state: ApplicationState): {
	isFetching: boolean;
	dataSources: DataSource[] | null;
	groupedDataSources: GroupedDataSource[] | null;
} {
	return {
		groupedDataSources: state.productSearchableDataSource.groupedDataSources,
		isFetching: state.productSearchableDataSource.isFetching,
		dataSources: state.productSearchableDataSource.dataSources,
	};
}

function mapDispatchToProps(dispatch: ThunkDispatch<AnyAction>): {
	onFetch: () => void;
} {
	return {
		onFetch: () => dispatch(fetchDataSourcesIfNeeded()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(DatasourceSelect);
